import { Link } from "react-router-dom";

const links = [
  { label: "首页", to: "/" },
  { label: "NBA直播", to: "/live" },
  { label: "NBA赛程", to: "/schedule" },
  { label: "赛事新闻", to: "/news" },
  { label: "关于我们", to: "/about" },
];

const friends = [
  { label: "NBA 官方网站", href: "https://mykchohq.cn" },
  { label: "篮球数据统计", href: "https://www.basketball-reference.com" },
  { label: "体育赛事资讯", href: "https://www.espn.com" },
];

export default function Footer() {
  return (
    <footer className="bg-primary-950 mt-16">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <span className="w-10 h-10 rounded-lg bg-accent-500 flex items-center justify-center text-accent-950 text-2xl">
                <i className="ri-basketball-line"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">
                NBA<span className="text-accent-400">直播吧</span>
              </span>
            </div>
            <p className="text-sm text-primary-300 leading-relaxed">
              专注NBA篮球比赛的实时直播与赛程信息，为广大篮球迷提供实时、全面的赛事动态和比赛实况。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">网站导航</h4>
            <ul className="space-y-2.5">
              {links.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-primary-300 hover:text-accent-400 transition-colors cursor-pointer">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">友情链接</h4>
            <ul className="space-y-2.5">
              {friends.map((f) => (
                <li key={f.href}>
                  <a
                    href={f.href}
                    target="_blank"
                    rel="noreferrer"
                    className="text-sm text-primary-300 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {f.label} <i className="ri-external-link-line text-xs"></i>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2.5 text-sm text-primary-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400"></i> contact@nba-zhibo.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line text-accent-400"></i> 微信公众号：NBA直播吧
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-accent-400"></i> 客服时间：每日 09:00 - 23:00
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-4 text-xl text-primary-300">
              <span className="w-9 h-9 rounded-md bg-primary-900 flex items-center justify-center cursor-pointer hover:text-accent-400">
                <i className="ri-weibo-fill"></i>
              </span>
              <span className="w-9 h-9 rounded-md bg-primary-900 flex items-center justify-center cursor-pointer hover:text-accent-400">
                <i className="ri-wechat-fill"></i>
              </span>
              <span className="w-9 h-9 rounded-md bg-primary-900 flex items-center justify-center cursor-pointer hover:text-accent-400">
                <i className="ri-youtube-fill"></i>
              </span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800">
          <p className="text-xs text-primary-400 leading-relaxed">
            免责声明：本站所有赛事直播、比分与新闻内容仅供球迷交流参考，直播区域为前端演示界面，未接入真实直播信号。本站与NBA官方无隶属关系，相关球队名称与标识仅用于信息描述，版权归各自所有者所有。
          </p>
          <div className="mt-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 text-xs text-primary-400">
            <span>© 2026 NBA直播吧 · 保留所有权利</span>
            <span>本站内容为演示数据 · 仅供学习交流使用</span>
          </div>
        </div>
      </div>
    </footer>
  );
}